import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import BreederProfileLayout from 'dpl/components/BreederProfile/Show/BreederProfileLayout';
import BreederProfileTestimonialsSection from 'dpl/components/BreederProfile/Show/BreederProfileTestimonialsSection';
import BreederProfileCurrentPuppiesSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileCurrentPuppiesSectionContainer';
import BreederProfileLittersSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileLittersSectionContainer';
import BreederProfileAdoptionProcessSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileAdoptionProcessSectionContainer';
import BreederProfileDeliverySectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileDeliverySectionContainer';
import BreederProfileAboutPuppiesSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileAboutPuppiesSectionContainer';
import { interviewResourceMapper } from 'dpl/containers/BreederProfile/Show/BreederProfileInterviewSectionContainer';
import BreederProfileHealthTestsSectionContainer, {
  healthTestsResourceMapper
} from 'dpl/containers/BreederProfile/Show/BreederProfileHealthTestsSectionContainer';
import BreederProfileParentsSectionContainer, {
  parentsResourceMapper
} from 'dpl/containers/BreederProfile/Show/BreederProfileParentsSectionContainer';
import BreederProfilePhotosSectionContainer, {
  photosResourceMapper
} from 'dpl/containers/BreederProfile/Show/BreederProfilePhotosSectionContainer';
import BreederProfileMoreAboutBreederSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileMoreAboutBreederSectionContainer';

function BreederProfileLayoutContainer(props) {
  return <BreederProfileLayout {...props} />;
}

export default compose(
  healthTestsResourceMapper,
  parentsResourceMapper,
  photosResourceMapper,
  interviewResourceMapper,
  connect((state, props) => ({
    topSections: [
      {
        Component: BreederProfileCurrentPuppiesSectionContainer,
        key: 'current-puppies'
      },

      {
        Component: BreederProfileLittersSectionContainer,
        key: 'litters'
      },

      {
        Component: BreederProfileAdoptionProcessSectionContainer,
        key: 'adoption-process'
      },
      {
        Component: BreederProfileAboutPuppiesSectionContainer,
        key: 'about-puppies'
      },

      {
        Component: BreederProfileDeliverySectionContainer,
        key: 'delivery'
      }
    ].filter(Boolean),
    sections: [
      {
        Component: BreederProfileMoreAboutBreederSectionContainer,
        key: 'more-about-breeder'
      },
      props.dogs.length && {
        Component: BreederProfileParentsSectionContainer,
        key: 'parents'
      },
      props.breedsWithHealthInfo.length && {
        Component: BreederProfileHealthTestsSectionContainer,
        key: 'health-tests'
      },
      props.imagesData.value.meta.public_gallery_photo_count && {
        Component: BreederProfilePhotosSectionContainer,
        key: 'photos'
      },

      {
        Component: BreederProfileTestimonialsSection,
        key: 'owner-stories',
        count: state.server.testimonialsCount
      }
    ].filter(Boolean)
  }))
)(BreederProfileLayoutContainer);
